import { render } from "./StackedBar.vue?vue&type=template&id=58ae89a2&scoped=true"
import script from "./StackedBar.vue?vue&type=script&lang=js"
export * from "./StackedBar.vue?vue&type=script&lang=js"

import "./StackedBar.vue?vue&type=style&index=0&id=58ae89a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ae89a2"]])

export default __exports__